import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetIqContactsForAccount as GetIqContactsForAccountQuery,
    GetIqContactsForAccountVariables,
} from 'nutshell-graphql-types';

import GET_IQ_CONTACTS_FOR_ACCOUNT from '../queries/get-iq-contacts-for-account.graphql';

export const useGetIqContactsForAccount = (accountId: string) => {
    const {loading, data, error, refetch} = useQuery<
        GetIqContactsForAccountQuery,
        GetIqContactsForAccountVariables
    >(GET_IQ_CONTACTS_FOR_ACCOUNT, {
        variables: {
            accountId,
        },
    });

    return {
        peopleIqContacts: data && data.account && data.account.peopleIqContacts,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
